interface IntelGlobeProps {
  id?: string;
  size?: number;
  bottom?: number;
  right?: number;
}

export function IntelGlobe({
  id = 'g',
  size = 36,
  bottom = 6,
  right = 6,
}: IntelGlobeProps) {
  const clipId = `globeClip_${id}`;
  return (
    <div
      style={{
        position: 'absolute',
        bottom: `${bottom}px`,
        right: `${right}px`,
        width: `${size}px`,
        height: `${size}px`,
        pointerEvents: 'none',
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        style={{ opacity: 0.42 }}
      >
        <defs>
          <clipPath id={clipId}>
            <circle cx="20" cy="20" r="15" />
          </clipPath>
        </defs>
        {/* Outer ring */}
        <circle
          cx="20"
          cy="20"
          r="15"
          fill="none"
          stroke="var(--color-accent)"
          strokeWidth="0.9"
        />
        {/* Inner structure - clipped to sphere */}
        <g clipPath={`url(#${clipId})`}>
          {/* Equator */}
          <ellipse
            cx="20"
            cy="20"
            rx="15"
            ry="4.2"
            fill="none"
            stroke="var(--color-accent)"
            strokeWidth="0.55"
          />
          {/* Latitude lines */}
          <ellipse
            cx="20"
            cy="12.5"
            rx="13"
            ry="2.8"
            fill="none"
            stroke="var(--color-accent)"
            strokeWidth="0.4"
          />
          <ellipse
            cx="20"
            cy="27.5"
            rx="13"
            ry="2.8"
            fill="none"
            stroke="var(--color-accent)"
            strokeWidth="0.4"
          />
          {/* Spinning longitude lines */}
          <g
            className="animate-globe-spin"
            style={{ transformOrigin: '20px 20px' }}
          >
            <ellipse
              cx="20"
              cy="20"
              rx="4"
              ry="15"
              fill="none"
              stroke="var(--color-accent)"
              strokeWidth="0.5"
            />
            <ellipse
              cx="20"
              cy="20"
              rx="9"
              ry="15"
              fill="none"
              stroke="var(--color-accent)"
              strokeWidth="0.45"
            />
            <ellipse
              cx="20"
              cy="20"
              rx="13.5"
              ry="15"
              fill="none"
              stroke="var(--color-accent)"
              strokeWidth="0.4"
            />
          </g>
          {/* Prime meridian - static vertical */}
          <line
            x1="20"
            y1="5"
            x2="20"
            y2="35"
            stroke="var(--color-accent)"
            strokeWidth="0.6"
            opacity="0.7"
          />
        </g>
        {/* Outer glow ring - breathing */}
        <circle
          cx="20"
          cy="20"
          r="17"
          fill="none"
          stroke="var(--color-accent)"
          strokeWidth="0.35"
          opacity="0.2"
        >
          <animate
            attributeName="r"
            values="17;18.5;17"
            dur="4s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="opacity"
            values="0.2;0.1;0.2"
            dur="4s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  );
}
